import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordTableAutoexclusionUsers from 'views/reports/autoexclusionUsers/recordTableAutoexclusionUsers'; // Importing a specific view component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for autoexclusion users.
 * @extends JetView
 */
export default class recordAutoexclusionUsersView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Historial'), // Localized label
                            localId: 'label',
                        },
                        { width: 4 },
                        {
                            view: 'text', // Search input field
                            localId: 'search',
                            hidden: true,
                            on: {
                                onTimedKeyPress() {
                                    // Event handler for timed key press
                                    this.$scope.$$('list').clearAll(); // Clear the list
                                    const input = this.getValue().toLowerCase(); // Get input value
                                    this.$scope.$$('list').load(
                                        devConfig.geturlApi() + // Load data based on input
                                            'es/Client/GetClientById?id=' +
                                            input,
                                    );
                                },
                            },
                        },
                        {
                            view: 'icon', // Icon for search functionality
                            icon: 'mdi mdi-magnify',
                            state: 'closed',
                            localId: 'search_icon',
                            click: function () {
                                // Click event to toggle search input
                                if (this.config.state === 'closed') {
                                    this.$scope.$$('label').hide(); // Hide label
                                    this.$scope.$$('search').show(); // Show search input
                                    this.$scope.$$('search').focus(); // Focus on search input
                                    this.config.state = 'open'; // Update state
                                } else if (this.config.state === 'open') {
                                    this.$scope.$$('label').show(); // Show label
                                    this.$scope.$$('search').hide(); // Hide search input
                                    this.config.state = 'closed'; // Update state
                                }
                            },
                        },
                        {
                            type: 'wide',
                            relative: true,
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon to navigate back
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                RecordTableAutoexclusionUsers, // Including the record table component
                toolbar, // Adding the toolbar
            ],
        };

        // Returning the main configuration object for the view
        return {
            height: screen.width < 500 ? 500 : 0, // Responsive height based on screen width
            type: 'wide',
            cols: [left], // Main layout with left panel
        };
    }
}

// FILE DOCUMENTED
